import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";

const ScrollToTop = () => {
  const location = useLocation();
  const previousPathname = useRef(location.pathname);

  useEffect(() => {
    console.log("Previous:", previousPathname.current, "| Current:", location.pathname);

    // Only scroll when pathname actually changes
    if (location.pathname !== previousPathname.current) {
      console.log("Previous: trigger")
      window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
      previousPathname.current = location.pathname;
    }
  }, [location]);

  return null;
};

export default ScrollToTop;
